module.exports = __webpack_public_path__ + "static/Roboto-Bold-2f6f533a6c4fb6b986e398c95e0c918e.woff2";